import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=4beca4b7&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=4beca4b7&prod&lang=sass&rel=stylesheets%2Fscss&scoped=true"
import style1 from "./Modal.vue?vue&type=style&index=1&id=4beca4b7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beca4b7",
  null
  
)

export default component.exports